// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2avxd","disabled":"FileBtn_disabled__28ySZ","warn":"FileBtn_warn__36msN","fade":"FileBtn_fade__31vs3"};